import { useState } from "react";

import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import CheckboxGroup from "@/components/CheckboxGroup";
import { AIRLINE_NAME_MAP } from "@/constants/airline";
import useThemeData from "@/hooks/useThemeData";
import { renderAirlineLogo } from "@/utils/commonRender";

import { useFilterContext } from "../FilterContext";

const FilterItemAirlines = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount } = useFilterContext();

  const [airlinesRule, setAirlinesRule] = useState("include");

  const { isDarkMode } = useThemeData();

  return (
    <div>
      <ToggleButtonGroup
        value={airlinesRule}
        exclusive
        onChange={(e, v) => {
          if (v) {
            setAirlinesRule(v);
          }
        }}
        aria-label="text alignment"
        sx={{
          width: "100%",
          ".MuiToggleButton-root": {
            padding: "3px",
            color: "primary.main",
            flex: 1,
          },
          ".Mui-selected": {
            color: "primary.main",
          },
        }}
      >
        <ToggleButton value={"include"} aria-label="include">
          Include
        </ToggleButton>

        <ToggleButton value={"exclude"} aria-label="exclude">
          Exclude
        </ToggleButton>
      </ToggleButtonGroup>
      {airlinesRule === "include" && (
        <CheckboxGroup
          key="include"
          options={filterOptions.airlinesOptions.map((item) => ({
            ...item,
            label: `${AIRLINE_NAME_MAP[item.label] ?? ""} (${item.label}) (${
              filterOptionsCount["airlines"][item.value]?.progress
            }/${filterOptionsCount["airlines"][item.value]?.total})`.replaceAll("undefined", "0"),
          }))}
          value={
            filterData.airlines.length > 0
              ? filterData.airlines
              : filterOptions.airlinesOptions.map(({ value }) => value)
          }
          onChange={(value) => {
            setFilterData({
              airlines: value,
            });
          }}
          renderPrefix={(params) => renderAirlineLogo(AIRLINE_NAME_MAP[params.value], isDarkMode)}
        />
      )}

      {airlinesRule === "exclude" && (
        <CheckboxGroup
          key="exclude"
          options={filterOptions.airlinesOptions.map((item) => ({
            ...item,
            label: `${AIRLINE_NAME_MAP[item.label] ?? ""} (${item.label}) (${
              filterOptionsCount["airlines"][item.value]?.progress
            }/${filterOptionsCount["airlines"][item.value]?.total})`.replaceAll("undefined", "0"),
          }))}
          value={filterData.excludeAirlines}
          onChange={(value) => {
            setFilterData({
              excludeAirlines: value,
            });
          }}
          renderPrefix={(params) => renderAirlineLogo(AIRLINE_NAME_MAP[params.value], isDarkMode)}
        />
      )}
    </div>
  );
};

export default FilterItemAirlines;
